import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about__container">
          <span>
              광고 클릭은 개발자에게 큰 돈이 됩니다.
          </span>
    </div>
  );
}

export default About;